module.exports = __webpack_public_path__ + "img/fashion_101.25fe78bc.jpg";